import ResetPassword from "./components/ResetPassword/ResetPassword";

export default ResetPassword;
